import { useEffect, useRef, useState } from "react";

import "./style.css";

const NOTE_EXAMPLES = ["Less sugar", "No sugar", "Less Ice", "No ice"];

const CartItemNoteModal = ({ item, onSave }) => {
  const [note, setNote] = useState("");
  const textareaRef = useRef(null);

  useEffect(() => {
    setNote(item?.note || "");
  }, [item]);

  useEffect(() => {
    const modal = document.getElementById("modal-cart-item-note");
    if (!modal) return undefined;

    const focusTextarea = () => window.setTimeout(() => textareaRef.current?.focus(), 120);
    modal.addEventListener("shown.bs.modal", focusTextarea);
    return () => modal.removeEventListener("shown.bs.modal", focusTextarea);
  }, []);

  const save = () => onSave?.(item?.product_id, note.trim());
  const clear = () => {
    setNote("");
    onSave?.(item?.product_id, "");
  };

  return (
    <div
      className="modal modal-blur fade pos-item-note-modal"
      id="modal-cart-item-note"
      tabIndex="-1"
      role="dialog"
      aria-hidden="true"
      data-bs-backdrop="static"
      data-bs-keyboard="false">
      <div className="modal-dialog modal-dialog-centered" role="document">
        <div className="modal-content">
          <div className="modal-header border-0 pb-0">
            <div className="pos-item-note-heading mt-3">
              <span className="pos-item-note-icon" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                  <path d="M5 4h14a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-8l-5 4v-4H5a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2z" />
                  <path d="M8 8h8M8 12h5" />
                </svg>
              </span>
              <div>
                <span className="text-primary text-uppercase fw-bold fs-6">Catatan pesanan</span>
                <h5 className="modal-title">{item?.product_name || "Pilih produk"}</h5>
                <p>Catatan ini hanya berlaku untuk item tersebut.</p>
              </div>
            </div>
            <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Tutup" />
          </div>

          <div className="modal-body pt-3">
            <label className="form-label fw-bold" htmlFor="cart-item-note">
              Catatan untuk dapur / barista
            </label>
            <textarea
              ref={textareaRef}
              id="cart-item-note"
              className="form-control pos-item-note-input"
              rows="4"
              maxLength="300"
              value={note}
              onChange={(event) => setNote(event.target.value)}
              placeholder="Contoh: less sugar, no sugar, saus dipisah, ..."
            />
            <div className="d-flex justify-content-between mt-2 gap-3">
              <span className="form-hint">Opsional · akan tampil di detail transaksi dan struk.</span>
              <span className="form-hint flex-shrink-0">{note.length}/300</span>
            </div>

            <div className="pos-item-note-examples" aria-label="Contoh catatan cepat">
              {NOTE_EXAMPLES.map((example) => (
                <button type="button" key={example} onClick={() => setNote(example)}>
                  {example}
                </button>
              ))}
            </div>
          </div>

          <div className="modal-footer border-0 pt-0">
            {item?.note ? (
              <button type="button" className="btn btn-ghost-danger me-auto" data-bs-dismiss="modal" onClick={clear}>
                Hapus catatan
              </button>
            ) : null}
            <button type="button" className="btn btn-link link-secondary" data-bs-dismiss="modal">
              Batal
            </button>
            <button type="button" className="btn btn-primary" data-bs-dismiss="modal" onClick={save} disabled={!item}>
              Simpan Catatan
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CartItemNoteModal;
